var geocoder;
var map;
var markers = [];
var bounds;

function initializeMap(mapElementId, address) {
	bounds = new google.maps.LatLngBounds();
	geocoder = new google.maps.Geocoder();
	map = new google.maps.Map(document.getElementById(mapElementId));

    if (address) {
        codeAddress(address);
    }
}

function codeAddress(address) {
	if (address != "" && geocoder) {
		geocoder.geocode({ 'address': address }, function (results, status) {
			if (status == google.maps.GeocoderStatus.OK) {
				markers[markers.length] = createMarker(results[0].geometry.location);
				bounds.extend(markers[markers.length - 1].position);
				map.fitBounds(bounds);
				setTimeout("setMapZoom(17);", 100);
			}
		});
	}
}

function createMarker(latlng) {
	var marker = new google.maps.Marker({ position: latlng, map: map });
	return marker;
}

var counter = 0;
function setMapZoom(maxZoomLevel) {
	if (map.getZoom() > maxZoomLevel)
		map.setZoom(maxZoomLevel);
	while (counter < 4 && map.getZoom() != maxZoomLevel) {
		counter++;
		setTimeout("setMapZoom(" + maxZoomLevel + ");", 1000);
	}
}

$(function () {
	$(".toggle-map").click(function () {
		$(".box .overlay").fadeToggle();
		$("#hide-map").fadeToggle();
		return false;
	});
});